"use client";

import { InsurancesSectionProps } from "@/Templates/SectionsProps";
import { FC } from "react";
import { renderGeneratedSection } from "./generated-section-renderer";
import { insurancesRenderers } from "./generated-sections-registry";

const GeneratedInsurancesSection: FC<InsurancesSectionProps> = (props) => {
  return renderGeneratedSection(
    props,
    insurancesRenderers,
    "Home1",
    (x) => x.setting.Appearance?.Key,
  );
};

export default GeneratedInsurancesSection;
